import { roundedRect } from '@bn-games/render-helpers';
import { formatClock } from '../../game/clock.js';
import type { Color } from '../../game/types.js';
import { BOARD_OUTER_OFFSET, BOARD_OUTER_SIZE, CANVAS_SIZE } from '../../utils/constants.js';
import type { RenderPalette } from '../palette.js';

export interface ClockView {
  readonly w: number;
  readonly b: number;
  readonly running: Color | null;
}

const PILL_WIDTH = 120;
const PILL_HEIGHT = 30;
const PILL_RADIUS = 15;
const DOT_RADIUS = 8;
const FONT = 'bold 16px "Segoe UI", system-ui, sans-serif';
const LOW_TIME_MS = 10_000;
const LOW_TIME_COLOR = '#ff6b5a';

function drawPill(ctx: CanvasRenderingContext2D, x: number, color: Color, ms: number, active: boolean, palette: RenderPalette): void {
  const y = BOARD_OUTER_OFFSET + BOARD_OUTER_SIZE + (CANVAS_SIZE - BOARD_OUTER_OFFSET - BOARD_OUTER_SIZE - PILL_HEIGHT) / 2;
  ctx.save();
  roundedRect(ctx, x, y, PILL_WIDTH, PILL_HEIGHT, PILL_RADIUS);
  ctx.fillStyle = active ? palette.bannerWinBg : palette.bannerBg;
  ctx.globalAlpha = active ? 1 : 0.75;
  ctx.fill();
  ctx.globalAlpha = 1;
  ctx.lineWidth = active ? 2 : 1;
  ctx.strokeStyle = palette.bannerBorder;
  ctx.stroke();

  const white = color === 'w';
  ctx.beginPath();
  ctx.arc(x + PILL_RADIUS, y + PILL_HEIGHT / 2, DOT_RADIUS, 0, Math.PI * 2);
  ctx.fillStyle = white ? palette.whitePieceBase : palette.blackPieceBase;
  ctx.fill();
  ctx.strokeStyle = white ? palette.whitePieceBorder : palette.blackPieceBorder;
  ctx.lineWidth = 1;
  ctx.stroke();

  ctx.font = FONT;
  ctx.textAlign = 'right';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = ms < LOW_TIME_MS ? LOW_TIME_COLOR : palette.bannerTextColor;
  ctx.fillText(formatClock(ms), x + PILL_WIDTH - PILL_RADIUS, y + PILL_HEIGHT / 2);
  ctx.restore();
}

/** Both clocks in the bottom gutter: White's on the left, Black's on the right. */
export function drawClocks(ctx: CanvasRenderingContext2D, clocks: ClockView, palette: RenderPalette): void {
  drawPill(ctx, BOARD_OUTER_OFFSET, 'w', clocks.w, clocks.running === 'w', palette);
  drawPill(ctx, BOARD_OUTER_OFFSET + BOARD_OUTER_SIZE - PILL_WIDTH, 'b', clocks.b, clocks.running === 'b', palette);
}
